import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(() => ({
  root: {
    height: 'auto',
    fontSize: (props) => props.fs || '18px',
    fontFamily: 'Source Sans Pro',
    textTransform: 'none',
    fontWeight: 600,
  },
  text: {
    width: 'auto',
    background: 'none',
    color: '#4CB255',
    '&:hover': {
      background: 'none',
      textDecoration: 'auto',
    },
    '&:disabled': {
      background: 'none',
      textDecoration: 'auto',
      color: '#B0B0B0',
    },
  },
  containedPrimary: {
    backgroundColor: '#4AA652',
    color: '#ffffff',
    height: 50,
    borderRadius: 6,
    '&:hover': {
      backgroundColor: 'rgba(114, 179, 128, 1)',
      textDecoration: 'none',
    },
    '&:disabled': {
      color: '#ffffff',
      backgroundColor: '#B0B0B0',
    },
  },
  outlined: {
    border: '1px dashed #4AA652',
    borderRadius: '6px',
    color: '#4AA652',
    padding: 0,
  },
  outlinedSecondary: {
    height: 50,
    border: '2px solid #D40C20',
    borderRadius: '6px',
    color: '#D40C20',
    fontSize: '18px',
    '&:hover': {
      border: '2px solid #D40C20',
    },
  },
  // disabled: {
  //   color: '#ffffff !important',
  //   backgroundColor: '#B0B0B0 !important',
  // },
}))

const ButtonStyled = ({
  fs,
  children,
  variant = 'contained',
  color = 'primary',
  fetchingIndicator = false,
  ...rest
}) => {
  const classes = useStyles({ fs })

  return (
    <Button
      classes={classes}
      fullWidth
      variant={variant}
      color={color}
      endIcon={
        fetchingIndicator ? (
          <CircularProgress
            size={20}
            style={{
              color: '#ffffff',
            }}
          />
        ) : null
      }
      {...rest}
    >
      {children}
    </Button>
  )
}

export default memo(ButtonStyled)
